export function neverCase(never: never): never {
  throw new Error('Unexpected');
}
